import {
  DataGridPremium,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  GridExcelExportMenuItem,
} from "@mui/x-data-grid-premium";
import { ptBR as ptBRCore } from "@mui/x-data-grid/locales";
import * as React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useCompany } from "../../components/context/CompanyContext";
import Loading from "../../components/loading/loading";
import "../../global.css";
import { userRequest } from "../../requestMethods";
import { formatPricing, formatTimeDDMMYYY } from "../../util/helper";
import Button from "@mui/material/Button";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Swal from "sweetalert2";
import CustomGrid from "../../components/grid/CustomGrid";
import {
  CART_PERIODS,
  DEFAULT_CART_PERIOD,
  buildAnaliticoCartsBody,
} from "../../util/cartPeriod";
export default function CartList() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const { companyId } = useCompany();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [time, setTime] = useState(DEFAULT_CART_PERIOD);
  const [selectionModel1, setSelectionModel1] = useState();
  useEffect(() => {
    if (companyId > 0) {
      getAnaliticoCartsTotal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, time]);

  const getAnaliticoCartsTotal = async () => {
    const res = await userRequest.post(
      `${companyId}/reportCarts/analiticoCarts`,
      buildAnaliticoCartsBody({ time })
    );

    setData(Array.isArray(res.data) ? res.data : []);
  };
  const onButtonDeleteClick = async (e, row) => {
    if (currentUser.isAdmin) {
      if (!e.target.checked) {
        Swal.fire({
          title: "Tem certeza que deseja apagar?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#EE8253",
          confirmButtonText: "Sim, apagar!",
          cancelButtonColor: "#d33",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await deleteCarts();
          } else {
            getAnaliticoCartsTotal();
          }
        });
      } else {
        await deleteCarts();
      }
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para inativar usuário!",
        "warning"
      );
    }
  };
  const deleteCarts = async () => {
    const res = await userRequest.post(`${companyId}/carts/olds`, {
      cartIds: selectionModel1,
    });

    if (res.data > 0) {
      getAnaliticoCartsTotal();
    } else {
      Swal.fire("Atenção!", "Erro ao inativar usuário!", "error");
    }
  };
  const columnsCart = [
    {
      field: "name",
      type: "text",
      headerName: "Nome",
      width: 200,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "contact",
      type: "text",
      headerName: "Contato",
      width: 100,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "quantity",
      type: "number",
      headerName: "Qtde de produtos",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "total",
      type: "number",
      headerName: "Total",
      width: 100,
      align: "center",
      headerAlign: "center",
      format: "BRL",
      valueFormatter: (value) => {
        if (value === null) {
          return "";
        }
        return `${formatPricing(value)}`;
      },
    },
    {
      field: "managedBy",
      type: "text",
      headerName: "Vendedor(a)",
      headerClassName: "dataGridMuiHeader",
      width: 100,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "updatedAt",
      headerName: "Data",
      width: 100,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
      format: "dd/MM/yyyy HH:mm:ss",
      valueGetter: (value) => value && new Date(value),
      valueFormatter: (value) => {
        return `${formatTimeDDMMYYY(value)}`;
      },
      type: "date",
    },
  ];
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }
  const GridToolbarExport = ({
    csvOptions,
    printOptions,
    excelOptions,
    ...other
  }) => (
    <GridToolbarExportContainer {...other}>
      <GridCsvExportMenuItem options={csvOptions} />
      <GridExcelExportMenuItem options={excelOptions} />
    </GridToolbarExportContainer>
  );
  return (
    <div className="cust-page">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="cust-title">Carrinhos</div>
          <div className="cust-card">
            <div className="cust-section-header">Lista de Carrinhos</div>
            <div style={{ display: "flex", gap: 8, padding: "16px 16px 0", flexWrap: "wrap" }}>
              {CART_PERIODS.map((p) => (
                <button
                  key={p.value}
                  onClick={() => setTime(p.value)}
                  style={{
                    padding: "4px 12px",
                    borderRadius: 8,
                    border: "1px solid #E5E7EB",
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 600,
                    fontFamily: "Manrope",
                    background: time === p.value ? "#EE8253" : "#fff",
                    color: time === p.value ? "#fff" : "#6B7280",
                    transition: "all 0.2s",
                  }}
                >
                  {p.label}
                </button>
              ))}
            </div>
            <div style={{ padding: "16px" }}>
              <CustomGrid
                toolbarActions={
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<DeleteOutlineIcon />}
                    onClick={onButtonDeleteClick}
                    size="small"
                  >
                    Apagar carrinhos
                  </Button>
                }
                gridId="cartList"
                rows={data}
                columns={columnsCart}
                pageSize={10}
                checkboxSelection={true}
                selectionField="cartId"
                selectionModel={selectionModel1}
                onSelectionChange={(selected, changed) => {
                  setSelectionModel1(selected);
                }}
              />
            </div>
          </div>
          {/* <div className="div_custom_UpdateLeft">
            <div style={{ height: 900 }}>
              <DataGridPremium
                autoHeight
                sx={{
                  fontFamily: "Manrope",
                  fontWeight: "500",
                  border: "0px",
                }}
                rowHeight={45}
                localeText={
                  ptBRCore.components.MuiDataGrid.defaultProps.localeText
                }
                slots={{ toolbar: CustomToolbar }}
                slotProps={{
                  panel: {
                    sx: {
                      top: "15px !important",
                      left: "50px !important",
                      position: "fixed !important",
                    },
                  },
                }}
                rowSelectionModel={selectionModel1}
                onRowSelectionModelChange={(itm) => {
                  setSelectionModel1(itm);
                }}
                getRowId={(row) => row.cartId}
                rows={data}
                disableSelectionOnClick
                columns={columnsCart}
                pagination
                autoPageSize
                checkboxSelection
              />
            </div>
          </div> */}
        </>
      )}
    </div>
  );
}
